import React, { useState } from "react";
import { Search, MapPin, Menu as MenuIcon, Globe, User, X } from "lucide-react";

const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-8">
            <a href="/" className="flex items-center gap-2">
              <img
                src="https://customer-assets.emergentagent.com/job_baan-mae-dining/artifacts/vhgsy54x_Logo%20BAAN%20MAE%20seul.webp"
                alt="BAAN MAE logo"
                className="h-11 md:h-12 w-auto object-contain"
              />
            </a>
            <nav className="hidden lg:flex items-center gap-6 text-sm text-gray-700">
              <a href="#a-propos" className="hover:text-[#1B7B71] transition-colors">À propos</a>
              <a href="#menu" className="hover:text-[#1B7B71] transition-colors">Menu</a>
              <a href="#avis" className="hover:text-[#1B7B71] transition-colors">Avis</a>
              <a href="#localisation" className="hover:text-[#1B7B71] transition-colors">Nous trouver</a>
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <button className="hidden md:flex items-center gap-1 text-sm text-gray-700 hover:text-[#1B7B71] transition-colors">
              <Globe className="h-4 w-4" /> FR
            </button>
            <a href="tel:+33632183554" className="hidden md:block text-sm text-gray-700 hover:text-[#1B7B71] transition-colors">06 32 18 35 54</a>
            <button
              onClick={() => document.getElementById("reservation")?.scrollIntoView({ behavior: "smooth", block: "start" })}
              className="flex items-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-[#1B7B71] rounded-full hover:bg-[#155f57] transition-colors"
            >
              <User className="h-4 w-4" />
              <span className="hidden sm:inline">Réserver</span>
            </button>
            <button onClick={() => setOpen(!open)} className="lg:hidden p-2">
              {open ? <X className="h-5 w-5" /> : <MenuIcon className="h-5 w-5" />}
            </button>
          </div>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-gray-200 bg-white px-4 py-3 space-y-2 text-sm">
          <a href="#a-propos" className="block py-2">À propos</a>
          <a href="#menu" className="block py-2">Menu</a>
          <a href="#avis" className="block py-2">Avis</a>
          <a href="#localisation" className="block py-2">Nous trouver</a>
        </div>
      )}
    </header>
  );
};

export default Header;
